import JumpHandler from './handlers/jump-handler';
import NextHandler from './handlers/next-handler';
import PrevHandler from './handlers/prev-handler';

const NavSurahToolInitiator = {
  init({
    page,
    btnNextSurah,
    btnPrevSurah,
    btnJumpPage,
    jumpPageContainer,
    formInputSurah,
    inputNumSurah,
    formBtnSubmitInputSurah,
    formBtnCloseInputSurah,
  }) {
    NextHandler.init(page, btnNextSurah);
    PrevHandler.init(page, btnPrevSurah);
    JumpHandler.init({
      btnJumpPage,
      jumpPageContainer,
      formInputSurah,
      inputNumSurah,
      formBtnSubmitInputSurah,
      formBtnCloseInputSurah,
    });
  },
};

export default NavSurahToolInitiator;
